'use strict';

import Vue from 'vue';
import request from 'superagent';
import api from './core';
import {sessionStorage} from './store';
import {escape} from '../utils';

const LATEST_KEY = 'todo-latest';

export const todoBus = new Vue();

/**
 * The header flashes the "to do" count in red if there is new ones in the
 * list. To that effect, the server publishes a "version" number which is
 * called "latest". Whenever this number changes it means that there is a new
 * thing in the list (however it does not change when a task is done).
 *
 * This function returns the latest value marked as seen.
 *
 * A value is marked as seen whenever visiting the "to do" page.
 */
export function getSeen() {
    return sessionStorage.getItem(LATEST_KEY);
}

/**
 * Set the seen value.
 * @see getSeen
 */
export function setSeen(seen) {
    sessionStorage.setItem(LATEST_KEY, seen);
}

/**
 * The latest value is handled by the header. Calling this method sends a
 * signal to the header that will mark the latest value as seen.
 *
 * @see getSeen
 */
export function seeLatest() {
    todoBus.$emit('see-latest');
}

/**
 * Trigger an update of the count in the header
 */
export function updateCount() {
    todoBus.$emit('update-count');
}

export function getCount() {
    const url = api.url('/todo/count/');
    const call = api.prepare(request.get(url));
    return api.forwardResult(call, 'todo');
}

export function getGrouped(page) {
    const url = api.url(`/todo/grouped/`);
    return api.forwardResult(
        api.prepare(request.get(url).query({page})),
        'results',
    );
}

/**
 * Gets the complete list of to do
 */
export function listAll(page, state = '', operation = '', start = '', stop = '') {
    const url = api.url(
        `/todo/?order=desc&attached_operation=${true}
              &state=${state}&operation=${operation}&start=${start}&stop=${stop}`
    );
    const res = api.forwardResult(
        api.prepare(request.get(url).query({page})),
        'results',
    );
    return res;
}

/**
 * Gets the list of to do for a single client
 */
export function listForClient(client, page) {
    const url = api.url(`/todo/`);
    return api.forwardResult(
        api.prepare(request.get(url).query({client, page})),
        'results',
    );
}

/**
 * Mark a to do as done (items manually marked are associated with the person
 * marking them)
 */
export function markDone(id, undo = false) {
    let url = api.url(`/todo/${id}/done/`);

    if (undo) {
        url += '?undo=yes';
    }

    return api.forwardResult(api.prepare(request.post(url)), 'id');
}

/**
 * Mute this TO DO
 */
export function mute(id, undo = false) {
    let url = api.url(`/todo/${id}/mute/`);

    if (undo) {
        url += '?undo=yes';
    }

    return api.forwardResult(api.prepare(request.post(url)), 'id');
}

/**
 * Format an info into a human-readable format, based on its slug
 */
export function formatInfo(info) {
    const {money, date} = Vue.options.filters;

    if (info.slug === 'duration') {
        if (info.value < 2) {
            return escape(info.value) + ' an';
        } else {
            return escape(info.value) + ' ans';
        }
    } else if (info.slug === 'invested_capital' ||
        info.slug === 'monthly_investment' ||
        info.slug === 'target_capital') {
        return money(info.value);
    } else if (info.slug === 'document_expiration') {
        return date(info.value, 'll');
    } else if (info.slug === 'project_type') {
        return ({
            simple: 'Simple',
            primo: 'Primo',
            monthly: 'Mensualisé'
        }[info.value]);
    } else if (info.slug === 'fiscal_framework') {
        return ({
            1: 'PEA',
            2: 'CTO',
            3: 'Assurance Vie',
            4: 'CTO CD'
        }[info.value]);
    } else {
        return escape(info.value);
    }
}

/**
 * Translate an info slug into a human-readable title
 */
export function infoTitle(slug) {
    const titles = {
        'project_name': 'Projet',
        'village': 'Village',
        'duration': 'Durée',
        'invested_capital': 'Capital initial',
        'monthly_investment': 'Versement mensuel',
        'target_capital': 'Capital cible',
        'life_plan': 'Projet de vie',
        'document_name': 'Nom',
        'document_expiration': 'Expiration',
        'document_type': 'Type',
        'project_type': 'Type',
        'fiscal_framework': 'Cadre juridique',
        'operation_type': 'Type'
    };

    return titles[slug] || slug;
}



// WEBPACK FOOTER //
// ./src/api/todo.js